module.exports = __webpack_public_path__ + "static/img/banner1.df43baa3.png";